export enum DocumentType {
  CUIT,
  DNI,
  RFC
}

const documentTypeMap: { [key in DocumentType]: string } = {
  [DocumentType.CUIT]: 'CUIL',
  [DocumentType.DNI]: 'DNI',
  [DocumentType.RFC]: 'RFC'
};

export const documentTypeToString = (val: DocumentType): string => {
  return documentTypeMap[val];
};
